import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-sm font-bold text-background-50">
                18
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">爆料网</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-600">
              把零散的热搜碎片，整理成前因后果都在的爆料合集。每日更新，追更不停。
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">内容栏目</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/category/star" className="transition-colors hover:text-primary-600">
                  明星八卦
                </Link>
              </li>
              <li>
                <Link to="/category/influencer" className="transition-colors hover:text-primary-600">
                  网红翻车
                </Link>
              </li>
              <li>
                <Link to="/category/submit" className="transition-colors hover:text-primary-600">
                  素人投稿
                </Link>
              </li>
              <li>
                <Link to="/category/deep" className="transition-colors hover:text-primary-600">
                  深度追踪
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">关于本站</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="transition-colors hover:text-primary-600">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="transition-colors hover:text-primary-600">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="transition-colors hover:text-primary-600">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">线索与反馈</h4>
            <p className="mb-3 text-sm leading-relaxed text-foreground-600">
              有内幕想爆料？投稿线索经核实后会被整理成专题。
            </p>
            <p className="flex items-center gap-2 text-sm text-foreground-700">
              <i className="ri-mail-line" aria-hidden="true"></i>
              tips@18bolaodaily.example
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 18爆料网 · 本站内容为虚构娱乐演绎，不指向任何现实人物。</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-primary-600">
              内容声明
            </Link>
            <Link to="/about#contact" className="transition-colors hover:text-primary-600">
              侵权处理
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}